import { render, staticRenderFns } from "./ArmariosPlanosView.vue?vue&type=template&id=34dfd982&scoped=true"
import script from "./ArmariosPlanosView.vue?vue&type=script&lang=js"
export * from "./ArmariosPlanosView.vue?vue&type=script&lang=js"
import style0 from "./ArmariosPlanosView.vue?vue&type=style&index=0&id=34dfd982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfd982",
  null
  
)

export default component.exports